// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"DrawerNotes__sidebar___2k1sf","sidebarHeader":"DrawerNotes__sidebarHeader___158Wy","title":"DrawerNotes__title___3dC1g","doubleDivider":"DrawerNotes__doubleDivider___DYtIp"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/common/header/drawerNotes/DrawerNotes.scss
// module id = 1235
// module chunks = 0